import ar from './json/ar.json';
import en from './json/en.json';

export default {
  en,
  ar,
};
